import { render, staticRenderFns } from "./tradeprice-list.vue?vue&type=template&id=61673ce4&"
import script from "./tradeprice-list.vue?vue&type=script&lang=js&"
export * from "./tradeprice-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeprice-list.vue"
export default component.exports